// Nieuwsbrief-pop-up rechtsonder (resources/views/components/newsletter-popup.blade.php), naar het voorbeeld van Scouters.
import axios from 'axios';

class NewsletterPopup {
    constructor(options = {}) {
        this.popup         = document.querySelector('.newsletter-popup');
        this.cookieName    = 'newsletter_popup_dismissed';
        this.showDelay     = options.showDelay || 3000;
        this.dismissDays   = options.dismissDays || 7;
        this.subscribeDays = options.subscribeDays || 365;
        this.previousFocus = null;

        if(!this.popup || this.isDismissed() || window.innerWidth < 768) {
            return;
        }

        this.bindEvents();
        setTimeout(() => this.show(), this.showDelay);
    }

    isDismissed() {
        return document.cookie.split(';').some((cookie) => cookie.trim().startsWith(this.cookieName + '=true'));
    }

    remember(days) {
        const expires = new Date();
        expires.setDate(expires.getDate() + days);
        document.cookie = `${this.cookieName}=true; expires=${expires.toUTCString()}; path=/; SameSite=Lax`;
    }

    isOpen() {
        return this.popup.style.display !== 'none';
    }

    show() {
        // Niet over een venster heen dat de bezoeker zelf opende, zoals het nieuwsbriefformulier.
        if(document.querySelector('.modal.show')) {
            return;
        }

        this.previousFocus      = document.activeElement;
        this.popup.style.display = 'block';

        setTimeout(() => this.popup.classList.add('show'), 10);

        // Pas na de overgang: zolang visibility nog hidden is, negeert de browser focus().
        setTimeout(() => this.popup.querySelector('.close-btn').focus(), 350);
    }

    hide(rememberForDays = this.dismissDays) {
        this.popup.classList.remove('show');
        this.remember(rememberForDays);

        setTimeout(() => {
            this.popup.style.display = 'none';
            this.previousFocus?.focus?.();
        }, 300);
    }

    getFocusableElements() {
        return Array.from(this.popup.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), [tabindex]:not([tabindex="-1"])'))
            .filter((element) => element.offsetParent !== null);
    }

    trapFocus(event) {
        const focusable = this.getFocusableElements();
        const first     = focusable[0];
        const last      = focusable[focusable.length - 1];

        if(event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
        } else if(!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
        }
    }

    bindEvents() {
        this.popup.querySelector('.close-btn').addEventListener('click', () => this.hide());

        document.addEventListener('keydown', (event) => {
            if(!this.isOpen()) {
                return;
            }

            if(event.key === 'Escape') {
                this.hide();
            } else if(event.key === 'Tab') {
                this.trapFocus(event);
            }
        });

        this.popup.querySelector('form').addEventListener('submit', (event) => {
            event.preventDefault();
            this.submit(event.target);
        });
    }

    // Lukt reCAPTCHA niet, dan versturen we zonder token; de server meldt dat dan.
    getRecaptchaToken(button) {
        return new Promise((resolve) => {
            if(!window.grecaptcha) {
                return resolve('');
            }

            window.grecaptcha.ready(() => window.grecaptcha.execute(button.dataset.sitekey, {action: button.dataset.action}).then(resolve, () => resolve('')));
        });
    }

    async submit(form) {
        const button  = form.querySelector('[type="submit"]');
        const label   = button.innerHTML;
        const message = this.popup.querySelector('#popup-newsletter-form-validation');

        button.disabled  = true;
        button.innerHTML = '<span class="spinner-border spinner-border-sm" role="status"><span class="visually-hidden">Bezig met inschrijven...</span></span>';
        message.className = 'alert d-none';
        form.querySelectorAll('.is-invalid').forEach((element) => element.classList.remove('is-invalid'));

        try {
            const formData = new FormData(form);
            formData.append('g-recaptcha-response', await this.getRecaptchaToken(button));

            const response = await axios.post(form.action, formData);

            message.textContent = response.data.message;
            message.className   = 'alert alert-success';
            form.remove();
            this.remember(this.subscribeDays);
        } catch(error) {
            const errors = error.response?.data?.errors || {};

            Object.keys(errors).forEach((field) => form.querySelector(`[name="${field}"]`)?.classList.add('is-invalid'));

            if(!Object.keys(errors).some((field) => form.querySelector(`[name="${field}"]`))) {
                message.textContent = errors['g-recaptcha-response']
                    ? 'We konden niet controleren of je geen robot bent. Ververs de pagina en probeer het opnieuw.'
                    : 'Er ging iets mis. Probeer het later opnieuw.';
                message.className = 'alert alert-danger';
            }

            button.disabled  = false;
            button.innerHTML = label;
        }
    }
}

if(document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => new NewsletterPopup());
} else {
    new NewsletterPopup();
}

export default NewsletterPopup;
